let ModulePopupContent = {
    Module: require("./modules/Module"),
    PopupContent: require("./modules/ModulePopupContent")
};
window.Modules = { ...window.Modules, ...ModulePopupContent};